import React from 'react'

export default function PrintDoc(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <mask
        id='mask0_8834_2668'
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='16'
        height='16'
      >
        <rect width='16' height='16' fill='currentColor' />
      </mask>
      <path
        d='M3.3335 14.6666C2.96683 14.6666 2.65294 14.5361 2.39183 14.275C2.13072 14.0139 2.00016 13.7 2.00016 13.3333V5.81665C1.80016 5.69442 1.63905 5.53609 1.51683 5.34165C1.39461 5.1472 1.3335 4.9222 1.3335 4.66665V2.66665C1.3335 2.29998 1.46405 1.98609 1.72516 1.72498C1.98627 1.46387 2.30016 1.33331 2.66683 1.33331H13.3335C13.7002 1.33331 14.0141 1.46387 14.2752 1.72498C14.5363 1.98609 14.6668 2.29998 14.6668 2.66665V4.66665C14.6668 4.9222 14.6057 5.1472 14.4835 5.34165C14.3613 5.53609 14.2002 5.69442 14.0002 5.81665V13.3333C14.0002 13.7 13.8696 14.0139 13.6085 14.275C13.3474 14.5361 13.0335 14.6666 12.6668 14.6666H3.3335ZM3.3335 5.99998V13.3333H12.6668V5.99998H3.3335ZM2.66683 4.66665H13.3335V2.66665H2.66683V4.66665ZM6.00016 9.33331H10.0002V7.99998H6.00016V9.33331Z'
        fill='currentColor'
      />
    </svg>
  )
}
